'use client'

/**
 * Mounted by property-scoped pages to point the floating WhatsApp button at
 * the property's own number and name. Renders nothing.
 */

import { useEffect } from 'react'
import { setWhatsAppOverride } from './whatsapp-float-store'

interface WhatsAppPropertyOverrideProps {
  whatsapp: string | null
  propertyName: string
}

export function WhatsAppPropertyOverride({ whatsapp, propertyName }: WhatsAppPropertyOverrideProps) {
  useEffect(() => {
    setWhatsAppOverride({ whatsapp, propertyName })
    return () => setWhatsAppOverride(null)
  }, [whatsapp, propertyName])

  return null
}
